import { useQuery } from '@tanstack/react-query';
import * as api from '@/src/api/sdk.gen';
import { apiFetch } from '@/src/lib/api-fetch';

export interface UserOrgInfo {
  id: number;
  name: string;
  slug: string;
  role: string;
  status?: string;
  logo_url?: string | null;
}

export interface UserProfileResponse {
  id: number;
  clerk_id: string;
  email?: string | null;
  name?: string | null;
  is_team_admin?: boolean;
  total_points?: number;
  product_tour_completed_at?: string | null;
  organizations?: UserOrgInfo[];
}

export function useUserProfile() {
  return useQuery<UserProfileResponse>({
    queryKey: ['user', 'me'],
    queryFn: async () => {
      try {
        const { data, error } = await api.getCurrentUserProfileApiV1UsersMeGet();
        if (!error && data) {
          return data as unknown as UserProfileResponse;
        }
      } catch {
        // Fallback to apiFetch
      }
      const res = await apiFetch('/api/v1/users/me');
      if (!res.ok) {
        throw new Error('Failed to fetch user profile');
      }
      return res.json();
    },
    staleTime: 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
